<template>
    <div class="contain">
        <div class="posting-uploader">
            <div
                    class="posting-uploader-item"
                    v-for="(item, index) in postData"
                    :key="index"
            >
                <img :src="item.url" alt="图片" class="imgPreview" @click="imagePreview(index)" />
                <van-icon
                        name="close"
                        @click="delImg(index)"
                        class="delte"
                />
            </div>
            <van-uploader
                    :after-read="uploadFile"
                    multiple
                    accept="image/*"
                    v-show=" postData.length < limit"
                    result-type="text"
                    upload-text="上传图片"
            >
            </van-uploader>
        </div>
        <!--<van-popup v-model="showLoading">-->
            <!--<van-loading type="spinner" color="#1989fa" />-->
        <!--</van-popup>-->
        <van-popup :close-on-click-overlay="false" v-model="showLoading">
            <div class="circle-div"><van-circle :stroke-width="60" :color="{
                                '0%': '#ffad19',
                                '100%': '#fec835',
                              }"  v-model="progress" :rate="progress" :speed="100" :text="progress+'%'" /></div>
            <div> <van-button
                    style="width: 3rem; margin-top: 10px"
                    size="normal" round native-type="button"  @click.stop="cancel">取消上传</van-button>
            </div>

        </van-popup>
    </div>
</template>

<script>
    import OSS from 'ali-oss';
    import {Uploader, Toast, Loading,Progress,Circle,ImagePreview } from 'vant';
    import Vue from 'vue';
    import jquery from 'jquery';


    Vue.use(Uploader).use(Toast).use(Loading).use(Progress).use(Circle).use(ImagePreview);
    var client = {};

    export default {
        props: {
            fileList: Array,
            limit: {
                type: Number,
                default: 0,
            },
            name: {
                type: String,
                default: ''
            }
        },
        data() {
            return {
                postData: [],
                uid: 0,
                progress: 0,
                showLoading: false,
                ossAccessTokenURL: 'https://api.ccachina.net/core/attachment/aliOssSts',
                ossFileURL: 'https://ccago.oss-cn-hangzhou.aliyuncs.com',
            }
        },
        mounted() {
            this.postData = this.fileList
            setTimeout(() =>{
                var ua = navigator.userAgent.toLowerCase();
                //判断是否是苹果手机，是则是true
                var isIos = (ua.indexOf('iphone') != -1) || (ua.indexOf('ipad') != -1);
                if (isIos) {
                    jquery("input:file").removeAttr("capture");
                };
            },500)
        },
        watch: {
            fileList(value) {
                this.postData = value
            }
        },
        methods: {
            cancel(){
                client.cancel();
                this.showLoading = false;
            },
            imagePreview(index){
                let that = this;
                ImagePreview({
                    images: that. fileList.map(item =>{
                        return item.url
                    }),
                    startPosition: index,
                });
            },
            delImg(index) {
                // 删除指定下标的图片对象
                let that = this;
                if (isNaN(index) || index >= that.postData.length) {
                    return false
                }

                this.postData.splice(index, 1)
                this.$emit('imageListChange', {'pic': that.postData, 'name': that.name})
            },

            uploadFile(evt) {
                console.log('------uploadFile------')
                alert(JSON.stringify(evt))
                let that = this;
                that.showLoading = true;
                OSS.urllib.request(that.ossAccessTokenURL, {method: 'GET'}, function (err, response) {
                    let result;
                    if (err) {
                        Toast.fail('上传异常:' + err);
                        console && console.error(err);
                        return;
                    }

                    try {
                        result = JSON.parse(response);
                    } catch (e) {
                        return alert('parse sts response info error: ' + e.message);
                    }

                    client = new OSS({
                        accessKeyId: result.data.AccessKeyId,
                        accessKeySecret: result.data.AccessKeySecret,
                        stsToken: result.data.SecurityToken,
                        endpoint: result.data.endpoint,
                        bucket: result.data.bucket,
                        secure: true
                    });

                    // alert(typeof  evt);
                    // return ;
                    if(typeof  evt.length != 'undefined'){
                        //多选
                        evt.map(evtItem =>{

                            console.log('evtItem.file', evtItem.file);
                            console.log(evtItem.file.size);
                            let typeList = ['image/jpeg', 'image/jpg', 'image/png']
                            if(typeList.indexOf(evtItem.file.type) == -1) {
                              Toast.fail(evtItem.file.name + '上传图片类型只能为jpeg,jpg和png');
                              that.showLoading = false;
                              return ;
                            }
                            if(evtItem.file.size>1000*1000*16){
                                Toast.fail(evtItem.file.name + '图片不能超过16M');
                                that.showLoading = false;
                                return ;
                            }
                            var suffix = evtItem.file.name.toLowerCase().split('.').splice(-1)[0];

                            var myDate = new Date().getTime();
                            let time = myDate + '' + (Math.floor(Math.random() * 1000 + 1));
                            let date = that.dateFormat(myDate);

                            var file_save_name = 'h5/' + date + '/' + time + '.' + suffix;
                            client.multipartUpload(file_save_name, evtItem.file,{
                                progress:function(p,checkpoint){
                                    console.log('----上传进度----')
                                    that.progress = parseInt(p*100);
//                            console.log(that.progress);
                                    console.log(p)
//                            console.log(p,checkpoint)
                                },

                            }).then(function (result) {
                                console.log(that.ossFileURL);
                                var file = {
                                    uid: 'vc-upload-'+time,
                                    url: that.ossFileURL + '/' + file_save_name,
                                    name: evtItem.file.name,
                                    save_name: file_save_name
                                }
                                that.postData.push(file);

                                that.showLoading = false;
                                // Toast.success(evtItem.file.name + '上传成功');
                                that.$emit('imageListChange', {'pic': that.postData, 'name': that.name})
                            }).catch(function (err) {
                                // Toast.fail(evtItem.file.name + '上传失败');
                            })

                        })


                    }else{
                        //单选

                        var suffix = evt.file.name.toLowerCase().split('.').splice(-1)[0];

                        console.log('evt.file');
                        console.log(evt.file.size);
                        let typeList = ['image/jpeg', 'image/jpg', 'image/png']
                        if(typeList.indexOf(evt.file.type) == -1) {
                          Toast.fail(evt.file.name + '上传图片类型只能为jpeg,jpg和png');
                          that.showLoading = false;
                          return ;
                        }
                        if(evt.file.size>1000*1000*16){
                            Toast.fail(evt.file.name + '图片不能超过16M');
                            that.showLoading = false;
                            return ;
                        }

                        var myDate = new Date().getTime();
                        let time = myDate + '' + (Math.floor(Math.random() * 1000 + 1));
                        let date = that.dateFormat(myDate);

                        var file_save_name = 'h5/' + date + '/' + time + '.' + suffix;
                        client.multipartUpload(file_save_name, evt.file,{
                            progress:function(p,checkpoint){
                                console.log('----上传进度----')
                                that.progress = parseInt(p*100);
//                            console.log(that.progress);
                                console.log(p)
//                            console.log(p,checkpoint)
                            },

                        }).then(function (result) {
                            console.log(that.ossFileURL);
                            var file = {
                                uid: 'vc-upload-'+time,
                                url: that.ossFileURL + '/' + file_save_name,
                                name: evt.file.name,
                                save_name: file_save_name
                            }
                            that.postData.push(file);

                            that.showLoading = false;
                            // Toast.success(evt.file.name + '上传成功');
                            that.$emit('imageListChange', {'pic': that.postData, 'name': that.name})
                        }).catch(function (err) {
                            // Toast.fail(evt.file.name + '上传失败');
                        })
                    }


                })
            },

        }
    }
</script>

<style scoped>
    .contain >>> .van-popup{
        background: none;
    }

    .posting-uploader {
        display: flex;
        flex-wrap: wrap;
    }

    .posting-uploader-item {
        position: relative;
        margin: 0 8px 8px 0;
    }

    .imgPreview {
        /*display: block;*/
        width: 80px;
        height: 80px;
    }

    .delte {
        /*margin-left: -15px;
        width: 10px;
        height: 10px;
        margin-right: 20px;*/
        position: absolute;
        right: 0;
        top: 0;
        padding: 1px;
        color: #fff;
        background-color: rgba(0, 0, 0, 0.45);
    }

    .upload-img-5 {
        margin: 5px 0 90px 0;
    }

    .upload-img-1 {
        margin: 5px 0 15px 0;
    }

    .circle-div{
        text-align: center;
    }
    .circle-div>>>.van-circle__text{
        color: #fff !important;
    }
</style>



// WEBPACK FOOTER //
// PicUploader2.vue?154f6fa2